import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Icon,
  Typography,
  Theme,
  useTheme,
  TIcons,
} from "@yuno/design-system-web";
import { useContext } from "react";
import { MainContext } from "../../context/main-context";
import { useTranslation } from "react-i18next";

const SideButton = styled.button<{ theme?: Theme; active?: boolean }>`
  width: 106px;
  transition: background 0.3s ease-in-out;
  background: ${({ active }) => (active ? "#f6f7fa" : "white")};
  padding: 10px;
  border: ${({ active, theme }) =>
    active ? "1px solid transparent" : `1px solid ${theme.palette.grey[2]}`};
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  & p {
    margin-top: 10px;
    ${({ theme }) => theme.typography.tiny.regular};
    color: ${({ theme }) => theme.palette.neutral.black};
  }
`;

const menu = [
  { id: "CONDITIONS", name: "conditions", icon: "GitFork" },
  { id: "STYLING", name: "styling", icon: "Monitor" },
];

export const SidebarNav = () => {
  const { page, setPage } = useContext(MainContext);
  const theme: Theme = useTheme();
  const { t } = useTranslation();

  const handleChangePage = (page) => {
    setPage(page);
  };

  return (
    <>
      {menu.map((item, key) => (
        <SideButton
          active={page == item.id}
          key={key}
          onClick={handleChangePage.bind(null, item.id)}
        >
          <Icon
            name={item.icon as TIcons}
            width="24px"
            height="24px"
            weight="light"
            color={
              page == item.id
                ? theme.palette.vivid.brand
                : theme.palette.grey[5]
            }
          />
          <Typography>{t(item.name)}</Typography>
        </SideButton>
      ))}
    </>
  );
};
